<!-- Page Content -->
<div id="page-content">
  <div class="container">
    <div class="row top-space">
      <!--MAIN Content-->
      <div class="col-md-8">
        <div id="page-main">
          <section id="about">
            <br>
            <header><h3>International Students</h3></header>
            <img src="assets/img/international_students_2021.jpg">
            <hr>
            <p>
              The University of Ruhuna which is a leading state university in Sri Lanka possesses a national and
              international reputation for its provision of unique opportunities and an excellent educational experience
              for undergraduates. The Faculty of Humanities and Social Sciences of the University of Ruhuna is one of
              the reputed faculties that has the privilege of welcoming international students. The faculty offers
              students an intellectually challenging education through certificate, diploma, and undergraduate
              programmes that are international in scope and interactive in content and approach. Students can select a
              prospective programme based on their qualifications. The potential applicants can use the following link
              to explore the options.
            </p>
            <hr>
            <hr>
          </section>
        </div><!-- /#page-main -->
      </div><!-- /.col-md-8 -->

      <!--SIDEBAR Content-->
      <div class="col-md-4">
        <div id="page-sidebar" class="sidebar">
          <br><br><br>
          <aside id="our-professors">
            <header>
              <h5>ACADEMIC YEAR 2020/2021</h5>
            </header>
            <div class="section-content">
              <div class="professors">
                <aside>
                  <header>
                    <h2>
                      <a href="https://www.ugc.ac.lk/attachments/2108_Foreign%20Admission%20Handbook%20-2020_2021.pdf">Click here for more information</a>
                    </h2>
                    <figure class="professor-description">
                      For any queries: contact Dr. Darshana Liyanage,<br>
                      International Student Advisor via <br><br>
                      Phone: +94702433533<br>
                      Email: darshana@sinh.ruh.ac.lk
                    </figure>
                  </header>
                </aside>
              </div><!-- /.professors -->
            </div><!-- /.section-content -->
          </aside><!-- /.our-professors -->
        </div><!-- /#sidebar -->
      </div><!-- /.col-md-4 -->

    </div><!-- /.row -->
  </div><!-- /.container -->
</div>
<!-- end Page Content -->
